import type { VokabelnPayload } from '@/core/types';

import type { AppDefinition } from '../types';
import { CardBack } from './CardBack';
import { CardFront } from './CardFront';
import { MissRow } from './MissRow';

/**
 * The vocabulary trainer for the citizenship test.
 *
 * The BAMF catalog tests civics knowledge but gates it behind dense
 * administrative German. If you can answer a question in English and still
 * fail it in German, the blocker is vocabulary, not civics — so this app
 * drills that vocabulary on its own.
 *
 * Uses `CardBack` (the split, the false-friend warning and the exam sentence
 * have nothing in common with the nouns-shaped shared back) but no custom
 * `Home` — the generic app-home layout works once its chips come from the
 * app definition rather than being hard-wired to CEFR levels.
 */
export const vokabelnApp: AppDefinition<VokabelnPayload> = {
  id: 'einbuergerungstest-vokabeln',
  display_name: 'Vokabeln',
  CardFront,
  CardBack,
  MissRow,
};
